import { store } from './store.js';
import {watchEffect,nextTick} from '../../libs/petite-vue.js';



export function Checkout(props){
	window.addEventListener('pageshow', (event) => {
		if (event.persisted) {
			// Страница загружена из bfcache — значит, вернулись "назад"
			location.reload();
		}
	});

	const phoneInput = document.querySelector("#checkout-phone");
	let iti_phone = null;
	if (phoneInput) {
		iti_phone = window.intlTelInput(phoneInput, {
			initialCountry: "es",
			preferredCountries: ["es", "ru", "fr", "pt"],
			utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@18.1.1/build/js/utils.js",
			nationalMode: false,
			autoInsertDialCode: true,
			autoHideDialCode: false,       // не скрывает код при потере фокуса
			formatOnDisplay: true,         // форматирует номер при вводе
			separateDialCode: true,        // разделяет код страны и номер телефона
		});
	}

	return{
		store,
		init: {
			...props,
		},
		data: {
			_nonce: wpData.nonce,
		},
		showErrors: false,
		get disсount() {
			return store.cart.discount ?? 0;
		},
		get fees() {
			return 0;
		},
		get total() {
			if (!store.cart || !store.cart.total || !store.checkout.deliveryMethod) return false;
			return +this.cartSubTotal + +this.GetDeliveryCost(store.checkout.deliveryMethod) + +this.fees - +this.disсount;
		},
		get cartTotal() {
			if (!store.cart || !store.cart.total) return 0;
			return store.cart.total;
		},
		get cartSubTotal() {
			if (!store.cart || !store.cart.subtotal) return 0;
			return store.cart.subtotal;
		},
		FormIsValid() {
			return this.isValid;
			//return this.$refs.submitForm && this.$refs.submitForm.checkValidity();
		},
		GetDeliveryCost(method_id) {
			if (!store.delivery.methods || !store.delivery.methods[method_id]) return 0;
			let matchedPrice = 0;
			let maxThreshold = 0;
				for (const rule of store.delivery.methods[method_id].prices) {
					const threshold = parseFloat(rule.cart_total);
					const price = parseFloat(rule.price);

					if (store.cart.total >= threshold && threshold >= maxThreshold) {
						maxThreshold = threshold;
						matchedPrice = price;
					}
				}
			return matchedPrice || 0;
		},
		GetDeliveryMethods(){
			if (!store.checkout.deliveryCountry || !store.checkout.deliveryZip) return;
			let data = {
				...this.data,
				action: 'get_shipping_methods',
				country: store.checkout.deliveryCountry,
				postcode: store.checkout.deliveryZip,
			}
			store.checkout.deliveryMethod = '';
			store.showRotateLogo = true;
			return new Promise((resolve, reject) => {
				store.SendAjaxRequest(data)
					.then(response => {
						if (response.success) {
							store.delivery.methods = response.data.methods;
							//console.log(store);
							resolve(response);
						} else {
							console.error(response.data.message);
							reject(response.data.message);
						}
					})
					.catch((err)=>{
						console.error(err);
						reject(err);
					})
					.finally(() => store.showRotateLogo = false);
			});
		},
		GetPaymentMethods(){
			if (!store.checkout.deliveryCountry || !store.checkout.deliveryZip || !store.checkout.deliveryMethod) return;
			let data = {
				...this.data,
				action: 'get_payment_methods',
				delivery_method_id: store.checkout.deliveryMethod,
			}
			store.showRotateLogo = true;
			return new Promise((resolve, reject) => {
				store.SendAjaxRequest(data)
					.then(response => {
						if (response.success) {
							store.payment.methods = response.data.methods;
							store.checkout.paymentMethod = '';
							resolve(response);
						} else {
							console.error(response.data.message);
							reject(response.data.message);
						}
					})
					.catch((err)=>{
						console.error(err);
						reject(err);
					})
					.finally(() => store.showRotateLogo = false);
				});
		},
		FocusNext(e) {
			const form = e.target.form
			if (!form) return

			const focusable = Array.from(form.querySelectorAll('input, select, textarea, button'))
				.filter(el => !el.disabled && el.type !== 'hidden' && el.offsetParent !== null)

			const index = focusable.indexOf(e.target)
			if (index > -1 && index < focusable.length - 1) {
				focusable[index + 1].focus()
			} else {
				const submitBtn = form.querySelector('button[type="submit"]')
				if (submitBtn) submitBtn.click()
			}
		},
		SetPhoneValidity(){
			if (!iti_phone.isValidNumber()) {
				phoneInput.setCustomValidity('phone is invalid')
				store.checkout.phone_full = '';
			} else {
				phoneInput.setCustomValidity('');
				store.checkout.phone_full = iti_phone.getNumber();
			}

		},
		SubmitCheckoutForm(){
			// 1. Извлекаем данные из store
			const cart = store.cart;
			const checkout = store.checkout;
			const delivery = store.delivery;

			// Стоимость доставки: находим выбранный метод по ID из checkout.deliveryMethod
			const selectedMethodId = checkout.deliveryMethod; // например "flat_rate:1"
			const selectedMethod = delivery.methods[selectedMethodId];
			const shippingCost = selectedMethod ? selectedMethod.rawCost : 0; // число (у вас 12)

			// Базовая сумма товаров (без доставки) — cart.subtotal = 16
			const subtotal = parseFloat(cart.subtotal); // 16
			// Итоговая сумма заказа (товары + доставка)
			const totalValue = subtotal + shippingCost; // 28

			// Валюта — EUR (фиксировано)
			const currency = 'EUR';

			// Налог включён в стоимость, не учитывается отдельно
			const tax = 0;

			// Купон (если есть) — берём первый из массива cart.coupons
			const coupon = (cart.coupons && cart.coupons.length > 0) ? cart.coupons[0].code : '';

			// Товары: преобразуем объект cart.items в массив для GA4
			const items = Object.values(cart.items).map(item => ({
				item_id: item.sku,                          // используем SKU как основной идентификатор
				item_name: item.name,
				price: parseFloat(item.price),
				quantity: item.quantity,
			}));

			const transactionId = 'temp_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);

			// 2. Формируем объект для GA4 purchase
			const purchaseData = {
				transaction_id: transactionId,
				value: totalValue,
				tax: tax,
				shipping: shippingCost,
				currency: currency,
				coupon: coupon,
				items: items
			};

			// 3. Отправляем событие в dataLayer
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({ ecommerce: null }); // очищаем предыдущие ecommerce-данные
			window.dataLayer.push({
				ecommerce: purchaseData
			});



			const form = document.createElement('form');
			form.id = 'ic_checkout_form';
			form.method = 'POST';
			form.action = window.location.pathname;
			form.style.display = 'none';

			const input = document.createElement('input');
			input.type = 'hidden';
			input.name = '_nonce';
			input.value = window.wpData.nonce;
			form.appendChild(input);


			for (const [key, value] of Object.entries(store.checkout)) {
				const input = document.createElement('input');
				input.type = 'hidden';
				input.name = key;
				input.value = value;
				form.appendChild(input);
			}

			document.body.appendChild(form);
			form.submit();
		},
		ValidateAndSubmit(){
			if (!this.$refs.submitForm.checkValidity()) {
				this.showErrors = true;
				const form = document.querySelector('form');
				const firstInvalid = form.querySelector(':invalid');

				if (firstInvalid) {
					firstInvalid.scrollIntoView({
						behavior: 'smooth',
						block: 'center'
					});
					firstInvalid.focus();
				}
				return;
			}
			store.showRotateLogo = true;
			this.SaveCheckoutData();
			this.SubmitCheckoutForm();
		},
		SaveCheckoutData(){
			if (store.checkout.saveData) {
				let dataToSave = {
					...store.checkout,
				};
				delete dataToSave.comment;
				localStorage.setItem('ic_checkout_data', JSON.stringify(dataToSave));
			} else {
				localStorage.removeItem('ic_checkout_data');
			}
		},
		RestoreCheckoutData(){
			const saved = localStorage.getItem('ic_checkout_data');
			if (saved) {
				try {
					const parsed = JSON.parse(saved);
					Object.assign(store.checkout, parsed);
					this.GetDeliveryMethods().then((result) => {
						if (parsed.deliveryMethod in result.data.methods) {
							store.checkout.deliveryMethod = parsed.deliveryMethod;
							this.GetPaymentMethods().then(() => {
								if (parsed.paymentMethod in store.payment.methods) {
									store.checkout.paymentMethod = parsed.paymentMethod;
								}
							});
						}
					});

				} catch(e) {
					console.warn('Ошибка парсинга сохранённых данных', e);
				}
			}
		},
		isValid: false,
		UpdateValidity(){
			this.isValid = this.$refs.submitForm.checkValidity();
		},
		OnMounted(){

			watchEffect( () =>{
				for(const key in store.checkout){
					const watchedVals = store.checkout[key]; // need to access the value to watch it
				}

				nextTick(() => {
					this.UpdateValidity();
				})
			});
			this.RestoreCheckoutData();
		},
	}
}